import React from "react";
import RydLoadingSpinner from "../components/widgets/RydLoadingSpinner";

import { wrap } from "./RydTestbedWrap";

function EurydiceLoadingSpinnerTestbed() {
  return wrap(
    <div>
      <h1>Eurydice Loading Spinner Testbed</h1>
      <RydLoadingSpinner />
    </div>
  );
}

export default EurydiceLoadingSpinnerTestbed;